/**
 * Every browser-storage key the storefront reads or writes. These names are
 * shared with the static pages (/go/, /claim/, /cart, /shadow-oracle/ …) and
 * the server, so they are part of the public contract and must not change.
 */
export const STORAGE_KEYS = {
  accessToken: 'mutatio618_access_token',
  tokenExpires: 'mutatio618_token_expires',
  cartId: 'mutatio618_cart_id',
  /** ΩΞ-TILL-MERCH-001: the cart's lines, [{variantId, quantity}] (shared with the static /cart page). */
  cartLines: 'mutatio618_cart_lines',
  /** The country the visitor last chose to ship to. */
  shipCountry: 'mutatio618_ship_country',
  checkoutPending: 'omega_checkout_pending',
  attribution: 'm618_attrib_v1',
  clientId: 'm618_cid',
  consent: 'm618_consent_v1',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

/** localStorage can throw (private mode, blocked storage); the site must keep working. */
export const storage = {
  get(key: StorageKey): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key: StorageKey, value: string): void {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      /* storage unavailable: the value simply does not persist */
    }
  },
  remove(key: StorageKey): void {
    try {
      window.localStorage.removeItem(key);
    } catch {
      /* storage unavailable */
    }
  },
};
